<template>
  <div>
    <!-- Card Image -->

    <v-row no-gutters justify="space-between" align="start">
      <img
        v-if="cardInfo.cardType"
        class="payment-card-img"
        :src="getCardLogo(cardInfo.cardType)"
        :alt="cardInfo.cardType"
      />

      <v-icon v-else class="payment-card-img">mdi-credit-card-outline</v-icon>
      <div class="text-center" v-if="canManageCard(cardInfo.id)">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-icon size="14" v-bind="attrs" v-on="on" :data-test-id="`${dataTestId}__mark-as-default-icon`">settings</v-icon>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in [{ title: 'Make as default' }]"
              :key="index"
              @click="() => makeAsDefaultPayment(cardInfo.id)"
              :data-test-id="`${dataTestId}__mark-as-default-list-item-${index+1}`"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-row>
    <p class="mt-3">{{ cardInfo.maskedCardNumber }}</p>
    <v-row no-gutters class="mt-2 text-left">
      <span class="font10 truncate-line"
        >Name: {{ cardInfo.firstName + ' ' + cardInfo.lastName }}</span
      >
    </v-row>
    <v-row no-gutters justify="space-between" align="center">
      <span class="font10"
        >Expires: {{ cardInfo.expirationMonth }}/{{
          cardInfo.expirationYear
        }}</span
      >

      <div v-if="isDefault === cardInfo.id" class="font10 card-active">
        <v-icon size="14">done</v-icon>
        <span>Active</span>
      </div>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'PaymentCard',
  props: ['cardInfo', 'makeAsDefaultPayment', 'isDefault', 'canManage','dataTestId'],
  computed: {
    getCardLogo: function() {
      return cardType => this.$images.PAYMENT_CARD_LOGO(cardType);
    },
    canManageCard: function() {
      return cardId =>
        this.canManage && this.isDefault && this.isDefault !== cardId;
    }
  }
};
</script>
<style scoped>
p {
  margin: 0px;
}
.card-active {
  border: 1px solid #58e2c2;
  border-radius: 8px;
  padding: 1px 3px;
}
.payment-card-img {
  width: 28px;
}
</style>
